module.exports = __webpack_public_path__ + "img/gravier_beige.57e1dd4f.jpg";